import { TimezoneDateTimePicker } from '@/components/_SiteWide/TimezoneDateTimePicker'
import { dayjsWithTimezone, type Timezone } from '@/utils/intl/dateTimeFormatters'
import { GraviButton, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import type { ICellEditorParams } from 'ag-grid-community'
import { Tooltip } from 'antd'
import dayjs, { type Dayjs } from 'dayjs'

import { forwardRef, useImperativeHandle, useState } from 'react'

export const DeliveryWindowCellEditor = forwardRef<any, ICellEditorParams>((props, ref) => {
  const [data, setData] = useState({
    ...props.data,
    carrier_window_start: dayjs(props.data.carrier_window_start),
    carrier_window_end: dayjs(props.data.carrier_window_end),
  })

  const onChange = (key: string, value: Dayjs, picker: 'date' | 'time', tz: Timezone) => {
    const timezone = data.carrier_window_start_local
    const current = dayjsWithTimezone(data[key], timezone)
    const changed = dayjsWithTimezone(value, timezone)
    const newValue =
      picker === 'date'
        ? changed.hour(current.hour()).minute(current.minute()).second(current.second())
        : current.hour(changed.hour()).minute(changed.minute()).second(changed.second())
    setData({ ...data, [key]: newValue })
  }
  const disableConfirm =
    data.carrier_window_end.isBefore(data.carrier_window_start) ||
    data.carrier_window_end.isSame(data.carrier_window_start)

  useImperativeHandle(ref, () => {
    return {
      getValue() {
        return {
          ...data,
          carrier_window_start: data.carrier_window_start.toISOString(),
          carrier_window_end: data.carrier_window_end.toISOString(),
        }
      },
    }
  })

  const handleCancel = () => {
    props.api.stopEditing(true)
  }

  const handleConfirm = () => {
    props.api.stopEditing(false)
  }

  return (
    <div className='p-4' style={{ backgroundColor: 'var(--bg-1)' }}>
      <Texto category='p2' className='pb-3'>
        Update Delivery Window
      </Texto>
      <Vertical gap='1em'>
        <Horizontal gap={8}>
          <Vertical gap={1}>
            <Texto>Start Date</Texto>
            <TimezoneDateTimePicker
              format='MM/DD/YYYY'
              picker='date'
              timezone={data.carrier_window_start_local}
              value={data.carrier_window_start}
              onChange={(value) => onChange('carrier_window_start', value, 'date', data.carrier_window_start_local)}
              allowClear={false}
            />
          </Vertical>
          <Vertical gap={1}>
            <Texto>Start Time</Texto>
            <TimezoneDateTimePicker
              format='h:mm A'
              picker='time'
              timezone={data.carrier_window_start_local}
              value={data.carrier_window_start}
              onChange={(value) => onChange('carrier_window_start', value, 'time', data.carrier_window_start_local)}
              allowClear={false}
            />
          </Vertical>
        </Horizontal>
        <Horizontal gap={8}>
          <Vertical gap={1}>
            <Texto>End Date</Texto>
            <TimezoneDateTimePicker
              format='MM/DD/YYYY'
              picker='date'
              timezone={data.carrier_window_end_local}
              value={data.carrier_window_end}
              onChange={(value) => onChange('carrier_window_end', value, 'date', data.carrier_window_end_local)}
              allowClear={false}
            />
          </Vertical>
          <Vertical gap={1}>
            <Texto>End Time</Texto>
            <TimezoneDateTimePicker
              format='h:mm A'
              picker='time'
              timezone={data.carrier_window_start_local}
              value={data.carrier_window_end}
              onChange={(value) => onChange('carrier_window_end', value, 'time', data.carrier_window_end_local)}
              allowClear={false}
            />
          </Vertical>
        </Horizontal>
        <Horizontal gap={6} width='100%' justifyContent='flex-end'>
          <GraviButton onClick={handleCancel}>Cancel</GraviButton>
          <Tooltip title={disableConfirm ? 'End date must be after start date' : ''}>
            <GraviButton color='primary' onClick={handleConfirm} disabled={disableConfirm}>
              Confirm
            </GraviButton>
          </Tooltip>
        </Horizontal>
      </Vertical>
    </div>
  )
})
